import { LOCAL_COOP_INPUT_ROUTER_VERSION } from '../engine/local-coop/LocalCoopInputRouter.js';

function assertMethod(value, method, name) {
  if (!value || typeof value[method] !== 'function') {
    throw new TypeError(`${name} must provide ${method}()`);
  }
}

export function installLocalCoopTestApi({
  baseApi,
  integration,
  windowRef = globalThis.window,
}) {
  if (!baseApi || typeof baseApi !== 'object') throw new TypeError('baseApi must be an object');
  for (const method of [
    'start',
    'stop',
    'dropPlayerTwo',
    'getStatus',
    'getDiagnostics',
    'updateCamera',
    'setVirtualDeviceInput',
    'clearVirtualDeviceInput',
    'captureInputSnapshot',
    'restoreInputSnapshot',
  ]) assertMethod(integration, method, 'integration');

  const baseCaptureSnapshot = typeof baseApi.captureSnapshot === 'function'
    ? baseApi.captureSnapshot.bind(baseApi)
    : null;

  const api = Object.freeze({
    ...baseApi,
    localCoopVersion: 1,
    localCoopInputRouterVersion: LOCAL_COOP_INPUT_ROUTER_VERSION,
    getLocalCoopStatus: () => integration.getStatus(),
    getLocalCoopDiagnostics: () => integration.getDiagnostics(),
    startLocalCoop: (options = {}) => integration.start(options),
    stopLocalCoop: (options = {}) => integration.stop(options),
    dropLocalCoopPlayerTwo: () => integration.dropPlayerTwo(),
    updateLocalCoopCamera: () => integration.updateCamera(),
    setLocalCoopVirtualDeviceInput: (deviceId, state = {}) => (
      integration.setVirtualDeviceInput(deviceId, state)
    ),
    clearLocalCoopVirtualDeviceInput: (deviceId) => integration.clearVirtualDeviceInput(deviceId),
    captureLocalCoopInputSnapshot: () => integration.captureInputSnapshot(),
    restoreLocalCoopInputSnapshot: (snapshot) => integration.restoreInputSnapshot(snapshot),
    captureSnapshot: baseCaptureSnapshot === null
      ? undefined
      : () => ({
        ...baseCaptureSnapshot(),
        localCoop: integration.getDiagnostics(),
      }),
  });

  Object.defineProperty(windowRef, '__SERPENT_TEST__', {
    configurable: true,
    enumerable: false,
    value: api,
  });

  return api;
}
